import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../navbar";
import Sidebar from "../sidebar";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100 dark:scrollbar-thumb-primary-dark-surface dark:scrollbar-thumb-primary-dark-secondary">
      {mobileOpen && (
        <button
          type="button"
          aria-label="Close navigation"
          className="fixed inset-0 z-40 bg-slate-950/50 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}
      <Sidebar
        onSetMobileOpen={() => setMobileOpen(!mobileOpen)}
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onCloseSidebar={() => setMobileOpen(false)}
      />
      <div className={`transition-all ${collapsed ? "lg:pl-[76px]" : "lg:pl-64"}`}>
        <Navbar
          onSetMobileOpen={() => setMobileOpen(!mobileOpen)}
          onSetCollapsed={() => setCollapsed(!collapsed)}
          collapsed={collapsed}
        />

        <main className="p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
